import React from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import VideoListItem from "./VideoListItem";

const VideoList = () => {

  const {data: videos, isLoading, isError} = useGetVideosQuery();

  let content;

  if(isLoading){
    content = <div>Loading...</div>
  }

  if(!isLoading && isError){
    content = <div>Something went wrong</div>
  }

  if(!isLoading && !isError && videos?.length === 0){
    content= <div>No videos available</div>
  }

  if(!isLoading && !isError && videos?.length > 0){
    content= videos.map((video) => <VideoListItem key={video.id} video={video}/>)
  }

  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
       {content}
    </div>
  );
};

export default VideoList;
